export const STAFF = 'STAFF';
export const ADMIN = 'ADMIN';
export const GLOBALADMIN = 'GLOBALADMIN';